import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';

const SUPPORTED_LANGS = ['en', 'es', 'pt', 'zh-cn'];

@Injectable({ providedIn: 'root' })
export class LangGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.validateOrRedirect(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.validateOrRedirect(childRoute);
  }

  private validateOrRedirect(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const langRaw = route.params?.['lang'] || '';
    const lang = langRaw.toLowerCase();
    if (SUPPORTED_LANGS.includes(lang)) {
      return true;
    }
    // Try to preserve path params when fixing language
    if (route.params?.['slug']) {
      return this.router.createUrlTree(['/', 'buenos-aires-blog', route.params['slug'], 'en']);
    }
    if (route.params?.['productId'] && route.params?.['productTitle']) {
      return this.router.createUrlTree(['/', route.params['productId'], route.params['productTitle'], 'en']);
    }
    const base = (route.routeConfig?.path || '').replace('/:lang', '');
    if (base) {
      return this.router.createUrlTree(['/', base, 'en']);
    }
    return this.router.createUrlTree(['/home', 'en']);
  }
}
